<script lang="ts">
  import { Progress, backdropBlur, fade } from "@/libs/ui"
  import type { HTMLAttributes } from "svelte/elements"

  let { progress = 0, ...props }: { progress?: number } & HTMLAttributes<HTMLDivElement> = $props()
</script>

<div
  {...props}
  class={["relative flex size-full flex-col items-center justify-center", props.class]}
>
  <i
    class="absolute inset-0 size-full backdrop-blur-3xl"
    transition:backdropBlur={{ delay: 150, px: 64 }}
  ></i>
  <Progress class="absolute max-w-[9.375rem] text-white" transition={fade} value={progress} />
</div>
